import { DEFAULT_PAGE_ID } from '@dtx-company/true-common/src/constants/page'
import { useCurrentPageId } from '@dtx-company/inter-app/src/hooks/useCurrentPageId'

export function useShouldEditPageInRedux(): { shouldEditPageInRedux: boolean } {
  const currentPageId = useCurrentPageId()

  return { shouldEditPageInRedux: currentPageId === DEFAULT_PAGE_ID }
}
